import React from 'react';

export default function Input({
  label,
  hint,
  error,
  right,
  className = '',
  ...props
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {label && (
        <label style={{ fontSize: '13px', fontWeight: 600, color: '#8B8FA8', paddingLeft: 2 }}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        <input
          className={`input ${error ? 'error' : ''} ${className}`}
          style={right ? { paddingRight: '64px' } : {}}
          {...props}
        />
        {right && (
          <div style={{
            position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
            display: 'flex', alignItems: 'center',
          }}>
            {right}
          </div>
        )}
      </div>
      {error && (
        <span style={{ fontSize: '12px', color: '#EF4444', paddingLeft: 2 }}>{error}</span>
      )}
      {hint && !error && (
        <span style={{ fontSize: '12px', color: '#4B5170', paddingLeft: 2 }}>{hint}</span>
      )}
    </div>
  );
}
